import { useEffect } from 'react';

/**
 * Fecha o modal/popover ao pressionar ESC.
 *
 * Listener é registrado no `document` (não no elemento do modal) pra cobrir
 * casos em que o foco está num input/textarea filho — onKeyDown no wrapper
 * não dispara porque o evento é consumido pelo input antes de bubblar.
 *
 * Convenção de uso em modal: passar `open` como guard e `onClose` como ação.
 * Quando `open=false`, o efeito não registra listener (zero overhead).
 *
 * @example
 *   useEscapeClose(open, onClose);
 */
export function useEscapeClose(open: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose();
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);
}
